module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.af7ae505.woff2";